import { Deserializable } from '../../deserializable';

export class DocumentTypeDto implements Deserializable {
  public AllowMultipleApplicants: boolean;
  public AllowUploadOfMultipleFiles: boolean;
  public Code: string;
  public Exclusive: boolean;
  public Name: string;

  public deserialize(input: any): this {
    Object.assign(this, input);

    return this;
  }
}
